<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="refresh-yard-local">
    <div class="yard-local-page-label">
        <div class="div-stations">
            <span class="lbls">{{configData?.yardLocalLabel.oprZone}}</span>
            <lms-lms-dropdown [inputId]='"yardAndLocalDropDown"' [tabindex]='tabLevel' styleClass="p-dropdown yard-local-dropdown" [options]="divisionList" [filter]="true" #selectedDiv (onChange)='selectedDiv.resetFilter(); changeDivision()' (onFocus)="selectedDiv.resetFilter(); divisionListFocus()"
                [(ngModel)]='selectedDivisionName' autoWidth="true">
            </lms-lms-dropdown>
        </div>
        <div class="div-stations">
            <span class="lbls">{{configData?.yardLocalLabel.allocationStation}}</span>
            <lms-lms-dropdown [inputId]='"yardLocalStationDropDown"' [options]="stationList" [tabindex]='tabLevel + 4' styleClass="p-dropdown yard-local-dropdown" [filter]="true" [disabled]="selectedDivisionName ? false : true" #selectedStat (onFocus)="selectedStat.resetFilter(); stationListFocus();" (onChange)='selectedStat.resetFilter(); changeStation()'
                [(ngModel)]='selectedStationName' autoWidth="true">
            </lms-lms-dropdown>
        </div>
    </div>
    <div class="last-refresh">
        <p>{{configData?.yardLocalLabel.lastRefreshed}}</p>
        <span><strong>{{lasteRefreshedTime ? lasteRefreshedTime : 'N/A'}}</strong></span>
    </div>
    <lms-tabs [tabs]="tabs" [editMode]="editMode?.status" (lmsTabChange)="lmsEventHandler($event)"></lms-tabs>
</div>